var tmModalBanner = $('#c-auth-modal .c-modal-header-banner');
var tmAuthModalSubtitleWrapper = $('.c-auth-component-description');
var tmAuthContinueWithEmailBtnEl = $('.tm-auth-continue-with-email');
var loginSignupWithFbBtnEl = $('[data-social-auth="facebook"]');
var loginSignupWithGoogleBtnEl = $('[data-social-auth="google"]');
var loginSignupWithAppleBtnEl = $('[data-social-auth="apple"]');
var tmAccountEmailFieldWrapper = $('.tm-account-email-div');
var tmAccountEmailFieldEl = $('.tm-account-email');
var tmAccountActionBtnEl = $('.tm-account-action-btn');
var tmAccountErrorMessageLineEl = $('.tm-account-error-message-line');
// a message the page came with (login.php's $preErrorMessage: an expired or failed sign-in link), which the first
// renderAuthFlow() shows again on the line that carried it, instead of emptying it (COOL 368; that line only, never the
// header modal's copy of the component, COOL 369)
var tmAccountServerMessageEl = tmAccountErrorMessageLineEl.not('.c-hidden').first();
var tmAccountServerMessage = tmAccountServerMessageEl.text().trim();
var tmAuthSocialButtonsWrapper = $('.c-auth-component .c__social__buttons');
var tmAuthSocialHrEl = $('.c-auth-component .c-hr');

tmAuth = function () {
    return {
        currentAuthFlow: 'initial',
        authWaitingCheckoutRedirectUrl: null,
        waitingForCheckoutRedirect: false,
        tmLoggedInUserData: {},
        visitorEmailFieldValue: '',
        forceReloadOnLogin: false,
        awaitingEmailMagicLinkLogin: false,
        watchForUserLoginInAnotherTabInterval: null,
        watchForUserLoginInAnotherTabTimeout: null,
        /* tm_user_logged_in holds the session's expiry: rewritten at every sign-in, gone at sign-out, so a different raw
           value means this browser signed in, out or as someone else, in any tab. As it was when the page loaded, and as
           of the page's last user-data refresh */
        loginCookieAtLoad: Cookies.get('tm_user_logged_in') || '',
        loginCookieAtRefresh: Cookies.get('tm_user_logged_in') || '',
        sitePreferencesPending: false, /* applySitePreferences() is still looking for the language link */
        sitePreferencesNavigating: false, /* its click is loading the page under the account's language */
        sitePreferencesClickedInPlace: false, /* its click translated this page in place */
        refreshingUserData: false, /* a stale-tab refresh is on its way */

        triggerUpdateUserData: function () {
            const loginCookie = Cookies.get('tm_user_logged_in') || ''; /* the sign-in this answer is for */
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "tm_blog_logged_in_user_data",
                    "tmv_identifier" : tmVisitorStore.getDetail('identifier'),
                },
                success ( returnJSON ) {
                    if (returnJSON.hasOwnProperty('tmUserData')) {
                        tmAuth.tmLoggedInUserData = returnJSON.hasOwnProperty('tmUserData') ? returnJSON.tmUserData : {} ;
                        jQuery(document).trigger('tmBlogUserLoginStatusChanged', { customerOrVisitorWishlists : returnJSON.customerOrVisitorWishlists ?? [], loginCookie : loginCookie });
                    }
                },
                complete () {
                    tmAuth.refreshingUserData = false;
                }
            })
        },

        /* The account's Language and Currency (Account settings, tmUserData.site_preferences), applied the way the pickers
           do (the currency through tmCurrency, the language by clicking its link in the list). Once per sign-in and after
           each change: the tm_site_prefs_applied cookie keeps what was applied, so a picker change sticks; signing out
           clears it (the ready handler below). The Temperature unit is applyTemperaturePreference's, the Measurement system
           applyMeasurementPreference's */
        applySitePreferences: function (sitePreferences) {
            const applied = (sitePreferences.language || '') + '|' + (sitePreferences.currency || '');
            if (Cookies.get('tm_site_prefs_applied') === applied) {
                return;
            }
            Cookies.set('tm_site_prefs_applied', applied, { path: '/', sameSite: 'Lax', secure: location.protocol === 'https:' });
            if (typeof sitePreferences.currency === 'string' && typeof tmCurrency !== 'undefined'
                && (!tmCurrency.selectedTmCurrency || tmCurrency.selectedTmCurrency.code !== sitePreferences.currency)) {
                tmCurrency.changeCurrency(sitePreferences.currency);
            }
            if (typeof sitePreferences.language === 'string') {
                const language = sitePreferences.language.replace(/[^A-Za-z-]/g, '');
                let tries = 0;
                tmAuth.sitePreferencesPending = true;
                const timer = setInterval(function () { /* the widget draws its links once its script has loaded */
                    const link = document.querySelector('.cool-gtranslate-wrapper a[data-gt-lang="' + language + '"]');
                    if (link || ++tries >= 50) {
                        clearInterval(timer);
                        if (link && !link.classList.contains('gt-current-lang')) {
                            /* with the redirect (cooldestinations) the click loads the page under the new language;
                               without it the page is translated in place */
                            tmAuth.sitePreferencesNavigating = !link.closest('.cool-gtranslate-wrapper-no-redirect');
                            tmAuth.sitePreferencesClickedInPlace = !tmAuth.sitePreferencesNavigating;
                            link.click();
                        }
                        tmAuth.sitePreferencesPending = false;
                        jQuery(document).trigger('tmSitePreferencesApplied');
                    }
                }, 100);
            }
        },

        /* The account's Temperature unit (Account settings) written to tmv-temperature, which tmTemperature reads. No
           picker to apply it to and no once-only check: on every sign-in data, on every page */
        applyTemperaturePreference: function (sitePreferences) {
            if ((sitePreferences.temperature === 'C' || sitePreferences.temperature === 'F')
                && tmVisitorStore.getTemperature() !== sitePreferences.temperature) {
                tmVisitorStore.setTemperature(sitePreferences.temperature); /* not tmTemperature.setPreference: it is the account's already */
            }
        },

        /* The account's Measurement system (Account settings) written to tmv-measurement, which tmMeasurement reads. As
           applyTemperaturePreference: no picker, no once-only check */
        applyMeasurementPreference: function (sitePreferences) {
            if ((sitePreferences.measurement === 'imperial' || sitePreferences.measurement === 'metric')
                && tmVisitorStore.getMeasurement() !== sitePreferences.measurement) {
                tmVisitorStore.setMeasurement(sitePreferences.measurement); /* not tmMeasurement.setPreference: it is the account's already */
            }
        },

        /* Header -> account: a Language or Currency picked in the header becomes the account's (Peter, 2026-10-08: the
           Site preferences rows mirror the pickers). Signed in only; never while applySitePreferences is applying the
           account's own (that change is the account's already); nothing when it is the account's value already, which
           is also what stops the two from feeding each other. Nothing before the signed-in data has come in (it carries the
           nonce): the currency set on every page load is not a pick. Once the server has saved it, site_preferences and
           tm_site_prefs_applied move with it, so the next page does not apply the old value back; a refused save (an
           expired nonce, 403, 400) leaves both as they were */
        saveSitePreference: function (key, value) {
            if (!tmAuth.isUserLoggedInToCurrentBlog() || tmAuth.sitePreferencesPending || tmAuth.sitePreferencesNavigating
                || typeof value !== 'string' || value === '') {
                return;
            }
            const userData = tmAuth.tmLoggedInUserData || {};
            if (!userData.site_preference_nonce || (userData.site_preferences || {})[key] === value) {
                return;
            }
            jQuery.post(ajaxurl, { action: 'tm_save_site_preference', key: key, value: value, nonce: userData.site_preference_nonce })
                .done(function (response) {
                    if (!response || !response.saved || tmAuth.tmLoggedInUserData !== userData) {
                        return; /* not saved, or the signed-in data was replaced meanwhile (it then carries the server's) */
                    }
                    const sitePreferences = userData.site_preferences || {};
                    sitePreferences[key] = value;
                    userData.site_preferences = sitePreferences;
                    Cookies.set('tm_site_prefs_applied', (sitePreferences.language || '') + '|' + (sitePreferences.currency || ''), { path: '/', sameSite: 'Lax', secure: location.protocol === 'https:' });
                });
        },

        /* The language the header's picker shows: GTranslate's current link, else (once it has had 5 s to draw) the /xx/
           path the redirect serves (tmCurrentLanguageCode). This read depends on GTranslate's markup; Prashant's router
           relaunch replaces it */
        headerLanguage: function (withPathFallback) {
            const link = document.querySelector('.cool-gtranslate-wrapper .gt-current-lang[data-gt-lang]');
            let language = link ? link.getAttribute('data-gt-lang') : '';
            if (!language && withPathFallback && typeof window.tmCurrentLanguageCode === 'function') {
                language = window.tmCurrentLanguageCode();
            }
            return String(language || '').replace(/[^A-Za-z-]/g, '');
        },

        /* tmv-language follows the header's language: on each page with the picker once it has drawn, and after a pick
           that translates in place. Only that explicit pick (isPick, gTranslateLanguageSelected) is saved as the
           account's: a page's language comes from its URL on cooldestinations, so an English page reached from Google or
           an email is no pick and must not overwrite the account's language (code review, 2026-10-08) */
        syncHeaderLanguage: function (isPick) {
            if (!document.querySelector('.cool-gtranslate-wrapper')) {
                return;
            }
            let tries = 0;
            const timer = setInterval(function () {
                let language = tmAuth.headerLanguage(false);
                if (!language && ++tries < 50) {
                    return;
                }
                clearInterval(timer);
                language = language || tmAuth.headerLanguage(true);
                if (language === '') {
                    return;
                }
                if (language !== tmVisitorStore.getLanguage()) {
                    tmVisitorStore.setLanguage(language);
                }
                if (isPick === true) {
                    tmAuth.saveSitePreference('language', language);
                }
                else {
                    tmAuth.saveRedirectLanguagePick(language);
                }
            }, 100);
        },

        /* A pick in the redirect-style picker (cooldestinations: the click loads the /xx/ page) is marked in sessionStorage
           (tmv-language-pick, the capture listener below) and saved as the account's here, on the page it loaded, when the
           header shows that language and the visitor is signed in; after the signed-in data, so applySitePreferences
           applying the account's own at sign-in goes first. The mark is cleared on every read, so a stale one never saves */
        saveRedirectLanguagePick: function (language) {
            let picked = '';
            try {
                picked = sessionStorage.getItem('tmv-language-pick') || '';
                sessionStorage.removeItem('tmv-language-pick');
            } catch (e) {}
            if (picked === '' || picked !== language || !tmAuth.isUserLoggedInToCurrentBlog()) {
                return;
            }
            if ((tmAuth.tmLoggedInUserData || {}).site_preference_nonce) {
                tmAuth.saveSitePreference('language', language);
            }
            else {
                jQuery(document).one('tmBlogUserLoginStatusChanged', function () {
                    tmAuth.saveSitePreference('language', language);
                });
            }
        },

        isWishlistPage: function () {
            return typeof tmBlogRequestJsVars !== 'undefined'
                && !!tmBlogRequestJsVars.custom_page_data
                && tmBlogRequestJsVars.custom_page_data.custom_page_type === 'wishlist';
        },

        /* The wishlist pages are drawn for whoever was signed in when they loaded: once that changes (signed in here or by
           the magic link in another tab, signed out or in elsewhere) the page reloads, so a visitor's list that moved into
           the account at sign-in opens as the account's, Share included. Never while the account's language is still being
           applied: applySitePreferences() marks it applied before its click, so a reload in between would lose it for good;
           it asks again when done (tmSitePreferencesApplied), and when its click loads the page itself, that load is the
           reload. A page translated in place may not have kept the language yet when it reloads, so the reloaded page
           applies the preferences once more (the login cookie then matches, so it does not reload again). Returns whether
           it reloads */
        reloadWishlistPageIfLoginChanged: function () {
            if (
                !tmAuth.isWishlistPage()
                || tmAuth.sitePreferencesPending
                || tmAuth.sitePreferencesNavigating
                || (Cookies.get('tm_user_logged_in') || '') === tmAuth.loginCookieAtLoad
            ) {
                return false;
            }
            if (tmAuth.sitePreferencesClickedInPlace) {
                Cookies.remove('tm_site_prefs_applied', { path: '/' });
            }
            window.location.reload();
            return true;
        },

        /* A tab coming back into view after this browser signed in, out or as someone else in another tab: its hearts,
           lists and header are the other identity's, and a heart click would save into a list the new one doesn't have.
           Refresh them the way a page load does (a wishlist page reloads). The login-status handler moves the baseline
           once the new data is in, so a failed request is tried again at the next focus. Known limit: a sign-in and
           sign-out elsewhere leave the cookie as it was, so this tab misses them, though that sign-in moved its
           visitor lists into the account */
        refreshIfLoginChangedElsewhere: function () {
            if ((Cookies.get('tm_user_logged_in') || '') === tmAuth.loginCookieAtRefresh || tmAuth.refreshingUserData) {
                return;
            }
            if (!tmAuth.reloadWishlistPageIfLoginChanged()) {
                tmAuth.refreshingUserData = true; /* once, though focus and visibilitychange both fire */
                tmAuth.triggerUpdateUserData();
            }
        },

        socialLoginNonce: function () {
            /* One random value per browser, kept in the cookie tm_social_nonce: auth-scripts.php hands it to Google and Apple,
               which mint it into the id token, and the server accepts a token only when its nonce is this cookie's value,
               so a token minted in another browser is refused. The pages are cached, so the server cannot issue it. */
            const found = document.cookie.match(/(?:^|;\s*)tm_social_nonce=([0-9a-f]{64})(?:;|$)/);
            let nonce = found ? found[1] : '';
            if (nonce === '') {
            try {
                const bytes = new Uint8Array(32);
                window.crypto.getRandomValues(bytes);
                nonce = Array.from(bytes, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
            } catch (e) {
                for (let i = 0; i < 64; i++) { nonce += Math.floor(Math.random() * 16).toString(16); }
            }
            }
            /* Written on every read, so the expiry slides with use and a page left open does not outlive its cookie */
            document.cookie = 'tm_social_nonce=' + nonce + '; path=/; max-age=86400; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
            return nonce;
        },

        /* The SDKs learn the nonce at load; re-initialise them with the cookie's current value right before a sign-in, so a
           page loaded long ago, or one that saw another tab mint a new value, still sends the nonce the server will accept */
        initGoogleSignIn: function () {
            const config = (window.tmSocialLoginConfig || {}).google;
            if (!config || typeof window.google === 'undefined') { return false; }
            window.google.accounts.id.initialize({
                client_id: config.client_id,
                callback: loginWithGoogleCredentialResponse,
                nonce: tmAuth.socialLoginNonce()
            });
            return true;
        },
        initAppleSignIn: function () {
            const config = (window.tmSocialLoginConfig || {}).apple;
            if (!config || typeof AppleID === 'undefined') { return false; }
            AppleID.auth.init({
                clientId: config.clientId,
                scope: 'name email',
                redirectURI: config.redirectURI,
                nonce: tmAuth.socialLoginNonce(),
                usePopup: true
            });
            return true;
        },

        triggerTmLoginForSocialMedia: function (socialType = '', data = {}) {
            tmAuth.authShowHideLoader(socialType, true);
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "login_to_blog_via_social_media",
                    "social_type": socialType,
                    "tmNonce": tmUtils.getAjaxRequestNonce(),
                    "fb_access_token": data.hasOwnProperty('fb_access_token') ? data.fb_access_token : '',
                    "google_credential": data.hasOwnProperty('google_credential') ? data.google_credential : '',
                    "apple_code": data.hasOwnProperty('apple_code') ? data.apple_code : '',
                    "apple_id_token": data.hasOwnProperty('apple_id_token') ? data.apple_id_token : '',
                    "apple_user_response": data.hasOwnProperty('apple_user_response') ? data.apple_user_response : [],
                },
                success ( returnJSON ) {
                    if (tmAuth.waitingForCheckoutRedirect) {
                        redirectToCheckoutPage();
                    }
                    else {
                        if (returnJSON.authSuccess) {
                            if (returnJSON.forceReload) {
                                window.location.reload();
                            }
                            else {
                                tmAuth.tmLoggedInUserData = returnJSON.hasOwnProperty('tmUserData') ? returnJSON.tmUserData : {} ;
                                jQuery(document).trigger('tmBlogUserLoginStatusChanged', { customerOrVisitorWishlists : returnJSON.customerOrVisitorWishlists ?? [] });
                            }
                        }
                        if(tmAuth.currentAuthFlow === 'signupForCoupon') {
                            tmAuth.currentAuthFlow = 'signupSuccessWithCoupon';
                            tmAuth.renderAuthFlow();
                        }
                        else if (!returnJSON.authSuccess) {
                            /* refused by the server (a stale nonce, an unverified email, a provider error): say so, keep the modal */
                            tmAccountErrorMessageLineEl.text('Sign-in did not complete. Please try again.').removeClass('c-hidden');
                        }
                        else {
                            tmAuth.authModalHide();
                        }
                        tmAuth.authShowHideLoader(socialType, false);
                    }
                },
                error(jqXHR, textStatus, errorThrown) {
                    window.location.reload();
                }
            })
        },

        triggerFbLoginSdk: function () {
            try {
                FB.login(function(response) {
                    if (response.hasOwnProperty('authResponse') && response.authResponse && response.authResponse.hasOwnProperty('accessToken')) {
                        tmAuth.triggerTmLoginForSocialMedia('facebook', {'fb_access_token' : response.authResponse.accessToken});
                    }
                }, {scope: 'public_profile,email'});
            } catch (e) {}
        },

        authShowHideLoader: function (whichButton, isLoaderAndDisabled = true) {
            let foundButtonEl = null;
            if (whichButton === 'facebook') {
                foundButtonEl = loginSignupWithFbBtnEl;
            }
            else if (whichButton === 'google') {
                foundButtonEl = loginSignupWithGoogleBtnEl;
            }
            else if (whichButton === 'apple') {
                foundButtonEl = loginSignupWithAppleBtnEl;
            }
            else if (whichButton === 'actionButton') {
                foundButtonEl = tmAccountActionBtnEl;
            }

            if (foundButtonEl && isLoaderAndDisabled) {
                tmAuth.authModalOverlay(false)
                tmUtils.showLoaderForSelector(foundButtonEl);
                foundButtonEl.attr('disabled', true);
            }
            if (foundButtonEl && !isLoaderAndDisabled) {
                tmAuth.authModalOverlay(true)
                tmUtils.hideLoaderForSelector(foundButtonEl);
                foundButtonEl.attr('disabled', false);
            }
        },

        /* Log in / sign up "Continue": greyed (c-btn-inactive) until the field holds a valid email address, then the
           solid button colour (c-solid-btn) — same check as the browser's type=email (Peter, 2026-09-19). The button
           is an <a>, so the greyed state is a class + aria-disabled and the click handler ignores it. */
        syncEmailActionBtn: function () {
            if (!['loginWithEmail', 'signupForCouponWithEmail'].includes(tmAuth.currentAuthFlow)) {
                return;
            }
            let emailValue = (tmAccountEmailFieldEl.val() || '').trim();
            let hasEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailValue);
            if (hasEmail) {
                tmAccountActionBtnEl.addClass('c-solid-btn').removeClass('c-btn-inactive').removeAttr('aria-disabled');
            }
            else {
                tmAccountActionBtnEl.addClass('c-btn-inactive').removeClass('c-solid-btn').attr('aria-disabled', 'true');
            }
        },

        authModalOverlay: function (toHide = true) {
            try {
                if (toHide) {
                    window.tmAuthModal.hideOverlay();
                }
                else {
                    window.tmAuthModal.showOverlay();
                }
            } catch (e) {}
        },

        authModalHide: function () {
            try {
                window.tmAuthModal.close();
            } catch (e) {}
        },

        renderAuthFlow: function () {
            //authFlows: initial, widgetPreCheckout, loginWithEmail, signupForCoupon, signupForCouponWithEmail, signupSuccessWithCoupon

            // Reset to default
            this.setPopupStyle('default');
            this.showHideBanner(false);
            tmAuthSocialHrEl.addClass('c-hidden');
            tmAuthModalSubtitleWrapper.removeClass('c-hidden').find('p').text('Earn rewards, check out faster, save favorites, and view tickets on any device with a free and easy account.');
            tmAccountEmailFieldEl.removeAttr('disabled');
            tmAccountActionBtnEl.removeClass('c-hidden tm-account-checkout-as-guest-btn tm-button-with-field c-solid-btn c-btn-inactive').removeAttr('aria-disabled').find('span').text('Or continue with Email');
            tmAccountActionBtnEl.addClass("c-btn-ghost").find("span").text("Continue with Email"); // the standard L ghost (Peter, 2026-09-19)
            tmAuthContinueWithEmailBtnEl.addClass('c-hidden');

            tmAuthSocialButtonsWrapper.removeClass('c-hidden');
            tmAccountEmailFieldWrapper.addClass('c-hidden');
            tmAccountErrorMessageLineEl.text('').addClass('c-hidden');
            if (tmAccountServerMessage) { // the page's own message, once, on its own line
                tmAccountServerMessageEl.text(tmAccountServerMessage).removeClass('c-hidden');
                tmAccountServerMessage = '';
            }
            // the header's back arrow only in the email steps (Peter, 2026-09-19)
            jQuery('#c-auth-modal .c-modal-back-button').toggleClass('c-hidden', !['loginWithEmail', 'signupForCouponWithEmail'].includes(tmAuth.currentAuthFlow));
            try {
                window.tmAuthModal.setTitle('Log in or sign up');
                window.tmAuthModal.allowCloseOnBody();
                window.tmAuthModal.showCloseIcon();
            } catch (e) {}
            let focusedDestinationTitle = tmVisitorStore.getFocusedDestinationName();
            let oneClickSavingsTitle = '1-click Savings!';
            if (focusedDestinationTitle !== null) {
                oneClickSavingsTitle = '1-click ' + focusedDestinationTitle + ' Savings!';
            }

            // Update on basis of flow
            if (tmAuth.currentAuthFlow === 'widgetPreCheckout'){
                try {
                    window.tmAuthModal.setTitle('Choose an option');
                    window.tmAuthModal.doNotAllowCloseOnBody();
                    window.tmAuthModal.hideCloseIcon();
                } catch (e) {}
                tmAuthModalSubtitleWrapper.addClass('c-hidden');
                tmAuthSocialHrEl.removeClass('c-hidden');
                tmAccountActionBtnEl.attr('data-action', 'tm-checkout-as-guest').addClass("tm-account-checkout-as-guest-btn").find("span").text('Checkout as guest');
            }
            else if (tmAuth.currentAuthFlow === 'loginWithEmail') {                             
                tmAccountEmailFieldWrapper.removeClass('c-hidden');
                tmAuthSocialButtonsWrapper.addClass('c-hidden');
                tmAccountActionBtnEl.attr('data-action', 'tm-magic-login-link').addClass("tm-button-with-field").removeClass("c-btn-ghost").find("span").text("Continue");
                tmAuth.syncEmailActionBtn();
                jQuery('#c-auth-modal').addClass("c-login-signup-modal");      
            }
            else if (tmAuth.currentAuthFlow === 'signupForCouponWithEmail') {
                this.setPopupStyle('footerSlideUp');
                this.showHideBanner(true);
                window.tmAuthModal.setTitle(oneClickSavingsTitle);
                tmAuthModalSubtitleWrapper.find('p').text('Sign up for a free and easy account we\'ll drop a promo code into the checkout for you automatically.');
                tmAccountEmailFieldWrapper.removeClass('c-hidden');
                tmAuthSocialButtonsWrapper.addClass('c-hidden');
                tmAccountActionBtnEl.attr('data-action', 'tm-magic-login-link').addClass("tm-button-with-field").removeClass("c-btn-ghost").find("span").text("Activate Savings");
                tmAuth.syncEmailActionBtn(); // greyed until the email is valid, like "Continue" (Peter, 2026-09-19)
            }
            else if (tmAuth.currentAuthFlow === 'signupForCoupon') {
                this.setPopupStyle('footerSlideUp');
                this.showHideBanner(true);
                window.tmAuthModal.setTitle(oneClickSavingsTitle);
                tmAuthContinueWithEmailBtnEl.removeClass('c-hidden');
                tmAuthModalSubtitleWrapper.find('p').text('Sign up for a free and easy account we\'ll drop a promo code into the checkout for you automatically.');
                tmAccountActionBtnEl.addClass('c-hidden');
            }
            else if (tmAuth.currentAuthFlow === 'signupSuccessWithCoupon') {
                this.setPopupStyle('footerSlideUp');
                this.showHideBanner(true);
                window.tmAuthModal.setTitle(oneClickSavingsTitle);
                tmAuthModalSubtitleWrapper.find('p').html("Promo code <strong>FRESH</strong> will be automatically added at checkout and you can now save favorites, earn rewards and view your tickets on any device.");
                tmAuthSocialButtonsWrapper.addClass('c-hidden');
                tmAccountActionBtnEl.addClass('c-hidden');
                Cookies.set('coupon_code', 'FRESH');
            }
            else { /* tmAuth.currentAuthFlow === 'initial' */
                tmAccountActionBtnEl.attr('data-action', 'or-continue-with-email');     
                jQuery('#c-auth-modal').addClass("c-login-signup-modal");     
                tmAuthContinueWithEmailBtnEl.removeClass('c-hidden');  
                tmAccountActionBtnEl.addClass('c-hidden');     
            }
        },

        showHideBanner: function (toShow = true) {
            if (toShow) {
                if ( tmModalBanner.length > 0 ){
                    let focusedImageUrl = tmVisitorStore.getFocusedImage();
                    if (focusedImageUrl !== null) {
                        tmModalBanner.find('img').attr('src', focusedImageUrl).attr('data-src', focusedImageUrl);
                    }
                    tmModalBanner.removeClass("c-hidden");
                    jQuery('#c-auth-modal').addClass("c-modal-header-has-banner");
                }
            }
            else {
                if ( tmModalBanner.length > 0 ){
                    tmModalBanner.addClass("c-hidden");
                    jQuery('#c-auth-modal').removeClass("c-modal-header-has-banner");
                }
            }
        },

        setPopupStyle: function(style) {
            if (style === 'footerSlideUp') {
                jQuery('#c-auth-modal').find('.c-modal-overlay').removeClass('c-modal-mobile-f c-modal-mobile-f-no-border').addClass('c-modal-mobile-footer-slide-in');
            }
            else {
                jQuery('#c-auth-modal').find('.c-modal-overlay').removeClass('c-modal-mobile-footer-slide-in').addClass('c-modal-mobile-f c-modal-mobile-f-no-border');
            }
        },

        isUserLoggedInToCurrentBlog: function () {
            let tmUserLoggedInCookieValidTill = Cookies.get('tm_user_logged_in');
            let currentTimestampInSeconds = Math.floor(Date.now() / 1000);
            return !!(tmUserLoggedInCookieValidTill && tmUserLoggedInCookieValidTill > 0 && tmUserLoggedInCookieValidTill > currentTimestampInSeconds);
        },

        updateNavMenuIfBlogUserLoggedIn: function () {
            let avatarIconEl = jQuery('.c-avatar-container .c-avatar-dropdown .c-user-circle .fa-circle-user');
            let userImageEl = jQuery('.c-avatar-container .c-avatar-dropdown .c-user-circle .c-user-circle-image');
            if (tmAuth.isUserLoggedInToCurrentBlog()) {
                let avatarImageShown = false;
                if (tmAuth.tmLoggedInUserData.hasOwnProperty('profile_pic') && tmAuth.tmLoggedInUserData.profile_pic.length > 0) {
                    tmUtils.isValidImageUrl(tmAuth.tmLoggedInUserData.profile_pic, function (isValid) {
                        if (isValid) {
                            userImageEl.find('img').attr('src', tmAuth.tmLoggedInUserData.profile_pic);
                            tmUtils.hideElementsForSelector(avatarIconEl);
                            tmUtils.showElementsForSelector(userImageEl);
                            avatarImageShown = true;
                        }
                    });
                }
                if (!avatarImageShown) {
                    tmUtils.showElementsForSelector(avatarIconEl);
                    tmUtils.hideElementsForSelector(userImageEl);
                }
                tmUtils.hideElementsForSelector(jQuery('[data-on-login="hide"]'));
                tmUtils.showElementsForSelector(jQuery('[data-on-login="show"]'));

                /* customer name at the top of the account dropdown */
                if (tmAuth.tmLoggedInUserData.hasOwnProperty('display_name') && tmAuth.tmLoggedInUserData.display_name.length > 0) {
                    jQuery('[data-customer-display-name]').text(tmAuth.tmLoggedInUserData.display_name);
                } else {
                    tmUtils.hideElementsForSelector(jQuery('.c-avatar-dropdown-header, .c-mobile-menu-account__name'));
                }

                /* wallet related ops */
                if(
                    tmAuth.tmLoggedInUserData.hasOwnProperty('wallet_balance_usd')
                    && tmAuth.tmLoggedInUserData.wallet_balance_usd > 0
                    && tmAuth.tmLoggedInUserData.hasOwnProperty('wallet_balance_display')
                ) {
                    jQuery('[data-customer-current-wallet-balance-display]').html(tmAuth.tmLoggedInUserData.wallet_balance_display)
                }

                if (
                    tmAuth.tmLoggedInUserData.hasOwnProperty('wallet_balance_usd')
                    && tmAuth.tmLoggedInUserData.wallet_balance_usd === 0
                ){
                   /* every display, not only the header link's: a tab that saw another account sign in elsewhere still shows the old amount */
                   jQuery("[data-customer-current-wallet-balance-display]").html("$0.00");
                }

                /* $0 and no wallet history: the header strip's rewards icon (sections/header.php, data-empty-wallet-href) keeps pointing at /rewards/ instead of the empty wallet; the menus' Wallet rows always open the wallet (#736) */
                let walletIsEmpty = !(tmAuth.tmLoggedInUserData.wallet_balance_usd > 0)
                    && !tmAuth.tmLoggedInUserData.wallet_has_activity;
                jQuery('[data-empty-wallet-href]').each(function () {
                    let link = jQuery(this);
                    let emptyHref = link.attr('data-empty-wallet-href');
                    if (walletIsEmpty && emptyHref) {
                        if (!link.attr('data-wallet-href')) {
                            link.attr('data-wallet-href', link.attr('href'));
                        }
                        link.attr('href', emptyHref);
                    }
                    else if (link.attr('data-wallet-href')) {
                        link.attr('href', link.attr('data-wallet-href'));
                    }
                });
            }
            else {
                tmUtils.hideElementsForSelector(jQuery('[data-on-login="show"]'));
                tmUtils.showElementsForSelector(jQuery('[data-on-login="hide"]'));
                /* a tab that saw a sign-out elsewhere drops the customer's photo */
                tmUtils.showElementsForSelector(avatarIconEl);
                tmUtils.hideElementsForSelector(userImageEl);
            }
        },

        triggerTmAccountSubmitBtn: function () {
            let action = tmAccountActionBtnEl.attr('data-action');
            let emailValidateRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (action === 'or-continue-with-email') {
                tmAuth.currentAuthFlow = 'loginWithEmail';
                tmAuth.renderAuthFlow();
            }
            if (action === 'tm-magic-login-link') {
                let isValidEmail = emailValidateRegex.test(tmAuth.visitorEmailFieldValue);
                if (isValidEmail) {
                    tmAuth.sendMagicLoginLink(tmAuth.visitorEmailFieldValue);
                }
                else {
                    tmAccountEmailFieldEl.addClass('danger');
                }
            }
            else if (action === 'tm-checkout-as-guest') {
                if (tmAuth.waitingForCheckoutRedirect) {
                    tmAuth.authShowHideLoader('actionButton', true);
                    redirectToCheckoutPage();
                }
                else {
                    try {
                        tmAuth.authModalHide();
                    } catch (e) {}
                }
            }
        },

        sendMagicLoginLink: function (email) {
            tmAuth.authShowHideLoader('actionButton', true);
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "tm_email_send_magic_login_link",
                    "email": email,
                    "tmNonce": tmUtils.getAjaxRequestNonce(),
                    'referer': window.location.href,
                    'onSuccess': tmAuth.currentAuthFlow === 'signupForCouponWithEmail' ? 'popupWithCouponSuccess' : ''
                },
                success ( returnJSON ) {
                    if (returnJSON.errorMessage.length > 0) {
                        tmAccountErrorMessageLineEl.text(returnJSON.errorMessage).removeClass('c-hidden');
                    }
                    else {
                        tmAccountErrorMessageLineEl.css("margin-top","0");
                        if (tmAuth.currentAuthFlow === 'signupForCouponWithEmail') {
                            tmAccountErrorMessageLineEl.text('We’ve emailed you a secure one-tap link to confirm your email and add your discount!').removeClass('c-hidden');
                        }
                        else {
                            tmAccountErrorMessageLineEl.text('We’ve emailed you a secure one-tap login link to access your account without a password!').removeClass('c-hidden');
                        }
                    }
                    tmAccountActionBtnEl.addClass('c-hidden');
                    tmAuthSocialButtonsWrapper.addClass('c-hidden');
                    tmAccountEmailFieldEl.attr('disabled', 'disabled');
                    tmAuth.authShowHideLoader('actionButton', false);
                    tmAuth.awaitingEmailMagicLinkLogin = true;
                    tmAuth.watchForUserLoginInAnotherTab();
                },
                error(jqXHR, textStatus, errorThrown) {
                    window.location.reload();
                }
            })
        },

        watchForUserLoginInAnotherTab: function () {
            if (tmAuth.awaitingEmailMagicLinkLogin) {
                /* the link sent again: stop the running watch first, so only one poll runs */
                clearInterval(tmAuth.watchForUserLoginInAnotherTabInterval);
                clearTimeout(tmAuth.watchForUserLoginInAnotherTabTimeout);
                const interval = setInterval(function () {
                    tmAuth.triggerUpdateUserData();
                }, 5000); /* check for user login every 5 seconds */
                tmAuth.watchForUserLoginInAnotherTabInterval = interval;

                tmAuth.watchForUserLoginInAnotherTabTimeout = setTimeout(function () {
                    clearInterval(interval); /* its own watch, never a newer one */
                }, 300000); /* Watch until 5 minutes and then stop the interval */
            }
        },

        openCouponSignupModal: function (forSuccess = false) {
            return; // the coupon sign-up popup ("1-click Savings!") is off on every page (Prashant, 2026-10-05)
            if (window.tmAuthModal === undefined) {
                return;
            }
            if (tmVisitorStore.getDetail('is_from_g_ttd') !== 'yes') {
                // return; // todo: enable when promo code popup making live
            }
            if (forSuccess && tmAuth.isUserLoggedInToCurrentBlog()) {
                tmAuth.currentAuthFlow = 'signupSuccessWithCoupon';
                tmAuth.renderAuthFlow();
                window.tmAuthModal.open();
                tmVisitorStore.deleteDetail('popupWithCouponSuccess');
            }
            else if (tmVisitorStore.getDetail('coupon-signup-modal') !== 'yes' && !tmAuth.isUserLoggedInToCurrentBlog()) {
                if (!['signupForCoupon', 'signupForCouponWithEmail'].includes(tmAuth.currentAuthFlow)) {
                    tmAuth.currentAuthFlow = 'signupForCoupon';
                }
                tmAuth.renderAuthFlow();
                window.tmAuthModal.open();
                if (!new URLSearchParams(window.location.search).has('next')) { // todo: remove the ?next check when promo code popup making live
                    tmVisitorStore.saveDetail('coupon-signup-modal', 'yes');
                }
            }
        }
    }
}(window);


jQuery(document).ready(function () {
    tmAuth.updateNavMenuIfBlogUserLoggedIn();
});

/* signed in with Language / Currency saved on Account settings: apply them, on pages that have the pickers (not the
   checkout, where nothing switches mid-payment). The Temperature unit and Measurement system on every page, pickers or not */
jQuery(document).on('tmBlogUserLoginStatusChanged', function () {
    if (!tmAuth.tmLoggedInUserData || !tmAuth.tmLoggedInUserData.site_preferences) {
        return;
    }
    tmAuth.applyTemperaturePreference(tmAuth.tmLoggedInUserData.site_preferences);
    tmAuth.applyMeasurementPreference(tmAuth.tmLoggedInUserData.site_preferences);
    if (jQuery('.cool-gtranslate-wrapper').length) {
        tmAuth.applySitePreferences(tmAuth.tmLoggedInUserData.site_preferences);
    }
});

/* Header -> account (saveSitePreference): the currency picked in the header, and a language picked in the header (an
   in-place pick, gTranslateLanguageSelected). Each page load only writes tmv-language (syncHeaderLanguage) */
jQuery(document).on('tm_currency_changed', function (e, data) {
    if (data && data.selectedTmCurrency) {
        tmAuth.saveSitePreference('currency', data.selectedTmCurrency.code);
    }
});
/* a Temperature unit set through tmTemperature.setPreference saved as the account's. '' (No preference) is not saved:
   tm_save_site_preference refuses it, so a signed-in account clears its unit on the Account settings page only */
jQuery(document).on('tm_temperature_changed', function (e, data) {
    if (data && typeof data.unit === 'string') {
        tmAuth.saveSitePreference('temperature', data.unit);
    }
});
/* a Measurement system set through tmMeasurement.setPreference saved as the account's, as tm_temperature_changed */
jQuery(document).on('tm_measurement_changed', function (e, data) {
    if (data && typeof data.unit === 'string') {
        tmAuth.saveSitePreference('measurement', data.unit);
    }
});
jQuery(document).on('gTranslateLanguageSelected', function () {
    setTimeout(function () { tmAuth.syncHeaderLanguage(true); }, 100); /* GTranslate moves gt-current-lang in its own click handler */
});
jQuery(function () {
    tmAuth.syncHeaderLanguage(false);
});
/* the redirect-style picker's links (languages-list.php, the wrapper without -no-redirect): mark the pick for the page it
   loads (saveRedirectLanguagePick). Capture phase, so it runs before GTranslate's own handler navigates */
document.addEventListener('click', function (e) {
    const link = e.target && e.target.closest ? e.target.closest('.cool-gtranslate-wrapper:not(.cool-gtranslate-wrapper-no-redirect) a[data-gt-lang]') : null;
    if (!link) {
        return;
    }
    try {
        sessionStorage.setItem('tmv-language-pick', link.getAttribute('data-gt-lang').replace(/[^A-Za-z-]/g, ''));
    } catch (err) {}
}, true);

jQuery(document).on('tmBlogUserLoginStatusChanged', function (e, data) {
    if (tmAuth.isUserLoggedInToCurrentBlog() && tmAuth.watchForUserLoginInAnotherTabInterval !== null) {
        tmAuth.awaitingEmailMagicLinkLogin = false;
        clearInterval(tmAuth.watchForUserLoginInAnotherTabInterval);
        tmAuth.authModalHide();
    }

    if (tmAuth.reloadWishlistPageIfLoginChanged()) {
        return;
    }
    /* the sign-in the new data is for: an answer to a request sent before a sign-in or sign-out elsewhere is stale, and the
       next focus then refreshes again */
    tmAuth.loginCookieAtRefresh = data && typeof data.loginCookie === 'string' ? data.loginCookie : (Cookies.get('tm_user_logged_in') || '');

    if (
        (
            (
                typeof tmBlogRequestJsVars !== 'undefined'
                && tmBlogRequestJsVars.hasOwnProperty('custom_page_data')
                && tmBlogRequestJsVars.custom_page_data.hasOwnProperty('is_custom_page')
                && tmBlogRequestJsVars.custom_page_data.hasOwnProperty('custom_page_type')
                && (
                    tmBlogRequestJsVars.custom_page_data.custom_page_type === 'login'
                    || tmBlogRequestJsVars.custom_page_data.custom_page_type === 'signup'
                )
            )
            || tmAuth.forceReloadOnLogin
        )
        && tmAuth.isUserLoggedInToCurrentBlog()
    ) {
        window.location.reload();
    }
    else {
        tmAuth.updateNavMenuIfBlogUserLoggedIn();
    }
});

jQuery(document).on('click', '[data-auth-force-redirect]', function () {
    tmAuth.forceReloadOnLogin = true;
});

loginSignupWithFbBtnEl.click(function () {
    tmAuth.triggerFbLoginSdk();
});

/* Create hidden google login button and bind click event to our custom button */
const createHiddenGoogleWrapper = () => {
    try {
        const googleLoginWrapper = document.createElement("div");
        googleLoginWrapper.style.display = "none";
        googleLoginWrapper.classList.add("custom-google-button");
        document.body.appendChild(googleLoginWrapper);
        window.google.accounts.id.renderButton(googleLoginWrapper, {
            type: "icon",
            width: "200",
        });
        const googleLoginWrapperButton = googleLoginWrapper.querySelector("div[role=button]");
        return {
            click: () => {
                if (googleLoginWrapperButton !== null) {
                    googleLoginWrapperButton.click();
                }
            },
        };
    } catch (e) {}
};
loginSignupWithGoogleBtnEl.click(function () {
    tmAuth.initGoogleSignIn(); // the current nonce, not the one from page load
    const googleButtonWrapper = createHiddenGoogleWrapper();
    googleButtonWrapper.click();
});

function loginWithGoogleCredentialResponse(googleResponse) {
    if (googleResponse.credential) {
        tmAuth.triggerTmLoginForSocialMedia('google', {'google_credential' : googleResponse.credential});
    }
}

loginSignupWithAppleBtnEl.click(function (e) {
    try {
        tmAuth.initAppleSignIn(); // the current nonce, not the one from page load
        /* signIn() returns a promise that rejects with a plain {error: 'popup_closed_by_user'} when the popup is closed;
           the try/catch does not reach it, so without this catch PostHog logs it as an unhandled rejection
           ("Object captured as exception with keys: error", nightly triage 2026-10-09..11). The outcome arrives
           through the AppleIDSignInOnSuccess / AppleIDSignInOnFailure events below */
        AppleID.auth.signIn().catch(function () {});
    } catch (e) {}
});

try {
    document.addEventListener('AppleIDSignInOnSuccess', (event) => {
        if (event.detail.authorization) {
            tmAuth.triggerTmLoginForSocialMedia('apple', {'apple_code' : event.detail.authorization.code ?? null, 'apple_id_token' : event.detail.authorization.id_token ?? null, 'apple_user_response': event.detail.user ?? []});
        }
    });
    document.addEventListener('AppleIDSignInOnFailure', (event) => {
    });
} catch (e) {}

tmAccountActionBtnEl.click(function (e) {
    e.preventDefault();
    if (tmAccountActionBtnEl.hasClass('c-btn-inactive')) {
        return; /* "Continue" is greyed until the email is filled in */
    }
    tmAuth.triggerTmAccountSubmitBtn();
});

tmAuthContinueWithEmailBtnEl.click(function (e) {
    e.preventDefault();
    tmAuth.previousAuthFlow = tmAuth.currentAuthFlow; // where the back arrow returns to
    if (tmAuth.currentAuthFlow === 'signupForCoupon') {
        tmAuth.currentAuthFlow = 'signupForCouponWithEmail';
    }
    else {
        tmAuth.currentAuthFlow = 'loginWithEmail';
    }

    tmAuth.renderAuthFlow();
});

// header back arrow (components/modal back-button): hidden until the email step, where it returns to the buttons
// it came from. Capture phase, so modal.js's own click handler (close + menu panel) never runs for this modal.
jQuery('#c-auth-modal .c-modal-back-button').addClass('c-hidden');
document.querySelector('#c-auth-modal .c-modal-back-button')?.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    tmAuth.currentAuthFlow = tmAuth.previousAuthFlow || 'initial';
    tmAuth.renderAuthFlow();
}, true);

$(document).on('input', '.tm-account-email' , function () {
    tmAuth.visitorEmailFieldValue = $(this).val();
    tmAccountEmailFieldEl.val(tmAuth.visitorEmailFieldValue);
    if (tmAuth.visitorEmailFieldValue.length > 0) {
        tmAccountEmailFieldEl.removeClass('empty').removeClass('danger')
    }
    else {
        tmAccountEmailFieldEl.addClass('empty');
    }
    tmAuth.syncEmailActionBtn();
});

// Return in the email field = "Continue", but only once the address is valid (the button is no longer greyed)
// and nothing is already sending (Peter, 2026-10-06)
$(document).on('keydown', '.tm-account-email', function (e) {
    if (e.key !== 'Enter' || e.isComposing) {
        return;
    }
    e.preventDefault();
    if (tmAccountActionBtnEl.hasClass('c-btn-inactive') || tmAccountActionBtnEl.hasClass('c-hidden') || tmAccountActionBtnEl.attr('disabled')) {
        return;
    }
    tmAuth.triggerTmAccountSubmitBtn();
});

jQuery(document).on('tmWidgetHandleCheckoutRedirect', function (e, data) {
    tmAuth.authWaitingCheckoutRedirectUrl = data.redirectTo;
    try {
        tmUtils.posthogCapture('checkout_initiated', {
            checkout_id: data.checkoutId ?? null
        })
    } catch (e) {}

    redirectToCheckoutPage();
    /*let canHaveAuthPopup = (typeof tmBlogRequestJsVars !== 'undefined' && tmBlogRequestJsVars.hasOwnProperty('tm_blog_id') && tmBlogRequestJsVars.tm_blog_id === 7)
        && window.tmAuthModal !== undefined
        && !tmAuth.isUserLoggedInToCurrentBlog();

    if (canHaveAuthPopup) {
        tmAuth.currentAuthFlow = 'widgetPreCheckout';
        tmAuth.renderAuthFlow();
        window.tmAuthModal.open();
        tmAuth.waitingForCheckoutRedirect = true
    }
    else {
        redirectToCheckoutPage();
    }*/
});

function redirectToCheckoutPage() {
    if (tmAuth.authWaitingCheckoutRedirectUrl !== null) {
        window.location.href = tmAuth.authWaitingCheckoutRedirectUrl;
    }
}

jQuery(document).ready(function () {
    if (jQuery('#c-auth-modal').length > 0) {
        window.tmAuthModal = Modal.add("#c-auth-modal");

        tmAuth.renderAuthFlow();
        if (!tmAuth.isUserLoggedInToCurrentBlog()) {
            Cookies.remove('tm_site_prefs_applied', { path: '/' }); /* signed out: the next sign-in applies the account's Language and Currency again */
        }
        if (tmAuth.isUserLoggedInToCurrentBlog() || tmVisitorStore.getDetail('identifier')) {
            tmAuth.triggerUpdateUserData(); /* logged-in users and known visitors both have wishlists to load */
        }
        else {
            /* a first-time visitor has nothing on the server yet: skip the uncached request and let the listeners run with no wishlists */
            jQuery(document).trigger('tmBlogUserLoginStatusChanged', { customerOrVisitorWishlists : [] });
        }

        /* stale tabs: back into view, focused, or restored from the back/forward cache after a sign-in change elsewhere */
        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'visible') {
                tmAuth.refreshIfLoginChangedElsewhere();
            }
        });
        window.addEventListener('focus', tmAuth.refreshIfLoginChangedElsewhere);
        window.addEventListener('pageshow', function (e) {
            if (e.persisted) {
                tmAuth.refreshIfLoginChangedElsewhere();
            }
        });
        jQuery(document).on('tmSitePreferencesApplied', function () {
            tmAuth.reloadWishlistPageIfLoginChanged();
        });

        if (new URLSearchParams(window.location.search).has('next')) { // todo: remove the ?next check when promo code popup making live
            setTimeout(function () {
                tmAuth.openCouponSignupModal();
            }, 3000);
        }

        if (tmVisitorStore.getDetail('popupWithCouponSuccess') === 'yes') {
            tmAuth.openCouponSignupModal(true);
        }
    }
});

jQuery(document).on('tmModal_closed_#c-auth-modal', function () {
    try {
        if (tmAuth.waitingForCheckoutRedirect) {
            redirectToCheckoutPage();
        }
        if (['signupForCoupon', 'signupForCouponWithEmail', 'loginWithEmail', 'signupSuccessWithCoupon'].includes(tmAuth.currentAuthFlow)) {
            tmAuth.currentAuthFlow = 'initial';
            tmAuth.renderAuthFlow();
        }
    } catch (e) {}
});

/*jQuery(document).on('userExitIntentDetected', function () { // todo: remove the ?next check when promo code popup making live
    tmAuth.openCouponSignupModal();
});*/

/*jQuery(document).on('tmModal_open_#c-auth-modal', function () {
    tmAuth.renderAuthFlow();
});*/
